var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found-container"},[_c('illustration-404'),_c('h2',[_vm._v(_vm._s(_vm.$t("error.page_not_found")))]),_c('div',{staticClass:"body-text text-content"},[_vm._v(" "+_vm._s(_vm.$t("error.page_not_found_description"))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }